import { createFileRoute } from '@tanstack/react-router';

import { SettingsPage } from '@/features/auth';

export const Route = createFileRoute('/_authenticated/settings')({
  component: SettingsPage,
  beforeLoad: () => ({
    breadcrumbs: [{ title: 'Settings', href: '/settings' }],
  }),
});
